import { render } from "./PayreconStatus.vue?vue&type=template&id=b959257a"
import script from "./PayreconStatus.vue?vue&type=script&lang=js"
export * from "./PayreconStatus.vue?vue&type=script&lang=js"
script.render = render

export default script